const WHO_BASE_URL = process.env.REACT_APP_WHO_BASE_URL;
const WHO_IRIS_BASE_URL = process.env.REACT_APP_WHO_IRIS_BASE_URL;
const WHO_FCTC_BASE_URL = process.env.REACT_APP_WHO_FCTC_BASE_URL;

export const INITIATIVES_MPOWER_URL = `${WHO_BASE_URL}/initiatives/mpower`;
export const IRIS_REPORT_URL = `${WHO_IRIS_BASE_URL}/handle/10665/381685`;
export const FCTC_BASE_URL = `${WHO_FCTC_BASE_URL}`;
